import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Portfolio from './Portfolio.jsx';
import SoulProject from './SoulProject.jsx';
import LanProject from './LanProject.jsx';
import OtpProject from './OtpProject.jsx';
import HealthIotProject from './HealthIotProject.jsx';
import SpanProject from './SpanProject.jsx';
import Certificates from './Certificates.jsx';
import GamesHub from './GamesHub.jsx';
import NeonGravityRunner from './NeonGravityRunner.jsx';
import './App.css';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Portfolio />} />
      <Route path="/soul-project" element={<SoulProject />} />
      <Route path="/lan-project" element={<LanProject />} />
      <Route path="/otp-project" element={<OtpProject />} />
      <Route path="/health-iot-project" element={<HealthIotProject />} />
      <Route path="/span-project" element={<SpanProject />} />
      <Route path="/certificates" element={<Certificates />} />
      <Route path="/games" element={<GamesHub />} />
      <Route path="/games/neon-gravity-runner" element={<NeonGravityRunner />} />
    </Routes>
  );
}

export default App;